import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AircraftProvider } from "../states/providers/AircraftProvider";
import { NotificationProvider } from "../states/providers/NotificationProvider";
const AppLayout = () => {
  return (
    <NotificationProvider>
      <AircraftProvider>
        <ToastContainer className="p-3 w-fit text-sm" />
        <Outlet />
      </AircraftProvider>
    </NotificationProvider>
  );
};

export default AppLayout;

